import {
  Alert,
  Dimensions,
  Linking,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import CustomText from "../../accessories/CustomText";
import { web } from "../../accessories/Platform";
import {
  AccordionItem,
  Button,
  InputBox,
  Separator,
  Title,
  WebPageView,
  context,
} from "../../accessories/accessories";
import { Fragment, useContext, useEffect, useState } from "react";
import {
  cleanValue,
  formatCurrency,
  getNextNoYear,
  handleAPI,
  handleGetZipCodeDetails,
  handleOpenPageURL,
  log,
} from "../../accessories/CommonFunctions";
import Dropdown from "../../accessories/DropDown";
import ScrollContainer from "../../accessories/ScrollContainer";
import Icon from "react-native-vector-icons/FontAwesome";
import XMLParser from "react-xml-parser";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import ArrowSpinner from "../../accessories/ArrowSpinner";
import { Modal } from "react-native";
import { REDIRECT_URL } from "@env";
import { Switch } from "react-native";
import { shareHtmlContent } from "../../accessories/RNComponents";

const isMobileWeb = Dimensions.get("window").width <= 480;
const AppraisalPayment = (props) => {
  const { contextDetails, setContextDetails } = useContext(context);
  const {
    footerButton = <></>,
    loanId = "",
    stateOptions = [],
    loanPurpose = "",
    UserId = 0,
    isSmallScreen = false,
    navigation,
    setTopEdge = () => {},
    triggerHiddenButtonClick = false,
    triggerHiddenButtonClickDone = () => {},
    ProcessPaymentDisabled = () => {},
    ProcessingStatus = () => {},
    alertMessage = {},
    setAlertMessage = () => {},
    setIsPaymentDone = () => {},
  } = props;

  const { userName, SessionId, loanId: iLoanId } = contextDetails;
  //============= State values===============//

  const [productDescription, setProductDescription] = useState(null),
    [borrowerPropertyAddress, setBorrowerPropertyAddress] = useState([]),
    productTitle = ["Product Description", "Product Amount"],
    [expirationOption] = useState({
      month: [
        { value: "0", label: "--Select--" },
        { value: "01", label: "01 - Jan" },
        { value: "02", label: "02 - Feb" },
        { value: "03", label: "03 - Mar" },
        { value: "04", label: "04 - Apr" },
        { value: "05", label: "05 - May" },
        { value: "06", label: "06 - Jun" },
        { value: "07", label: "07 - Jul" },
        { value: "08", label: "08 - Aug" },
        { value: "09", label: "09 - Sep" },
        { value: "10", label: "10 - Oct" },
        { value: "11", label: "11 - Nov" },
        { value: "12", label: "12 - Dec" },
      ],
      year: [{ value: "0", label: "--Select--" }, ...getNextNoYear(10)],
    }),
    [creditCardDetails, setCreditCardDetails] = useState({
      paymentType: 0,
      CardNum: "",
      CardSecurityCode: "",
      ExpMonth: "",
      ExpYear: "",
      CardType: "",
      FirstName: "",
      LastName: "",
      Address: "",
      ZipCode: "",
      City: "",
      State: "",
      CardEmail: "",
    }),
    [creditCardDetailsValidation, setCreditCardDetailsValidation] = useState(
      []
    ),
    [showWarning, setShowWarning] = useState(false),
    [processingStatus, setProcessingStatus] = useState("pageLoading"),
    [alertModalMessage, setAlertModalMessage] = useState({
      messageArray: null,
      isShow: false,
    }),
    [pageConditions, setPageCondition] = useState({
      intRequestType: 3,
      iPayor: 2,
      whdnPayerValue: 0,
      strCMSLeftNavPayor: 2,
      loanPurpose,
    }),
    [borrowerToPay, setBorrowerToPay] = useState([]),
    [borrowerToPayAmount, setBorrowerToPayAmount] = useState(0),
    [rawJsonCardDetails, setRawJsonCardDetails] = useState({}),
    [productTotalAmount, setProductTotalAmount] = useState(0),
    [isPaid, setIsPaid] = useState(null),
    [selectedFeeId, SetSelectedFeeId] = useState([]);

  //============= State vales - End ===============//

  //============= UseEffect ===============//
  useEffect(() => {
    // Click the hidden button when triggerHiddenButtonClick is called

    // alert(triggerHiddenButtonClick + " " + processingStatus + " " + pageConditions["Proceed"] + " " + productDescription?.length + " " + triggerHiddenButtonClick);
    if (triggerHiddenButtonClick) {
      if (
        processingStatus !== "Next" &&
        pageConditions["Proceed"] != 0 &&
        productDescription?.length > 0 &&
        creditCardDetails["paymentType"] !== 0
      ) {
        // setProcessingStatus("Next");
        handleNextClick();
        triggerHiddenButtonClickDone(true);
      }
    }
  }, [triggerHiddenButtonClick]);

  useEffect(() => {
    setTimeout(() => {
      let disabled =
        processingStatus === "Next" ||
        pageConditions["Proceed"] == 0 ||
        productDescription?.length == 0 ||
        creditCardDetails["paymentType"] === 0 ||
        creditCardDetails["paymentType"] === "0" ||
        creditCardDetails["paymentType"] === undefined;
      ProcessPaymentDisabled(disabled);
    }, 500);
  }, [
    processingStatus,
    pageConditions,
    productDescription,
    creditCardDetails,
    ProcessPaymentDisabled,
  ]);

  useEffect(() => {
    ProcessingStatus(processingStatus);
  }, [processingStatus]);

  useEffect(() => {
    borrowerToPay.length > 0 &&
      setAlertModalMessage({
        messageArray: (
          <>
            <View style={{ flexDirection: "row", marginBottom: 10 }}>
              <CustomText style={{ width: "33.3%" }}>Borrower</CustomText>
              <CustomText style={{ width: "33.3%" }}>Amount</CustomText>
              <CustomText style={{ width: "33.3%" }}>
                Include in order
              </CustomText>
            </View>
            {borrowerToPay.map((row, index) => {
              return (
                <Fragment key={index}>
                  <View style={{ flexDirection: "row" }}>
                    <CustomText style={{ width: "33.3%" }}>
                      {row["Name"]}
                    </CustomText>
                    <CustomText style={{ width: "33.3%" }}>
                      {formatCurrency(row["amount"])}
                    </CustomText>
                    <CustomText style={{ width: "33.3%" }}>
                      <Switch
                        trackColor={{ false: "#767577", true: "#468fcc" }}
                        thumbColor={row["isSelected"] ? "#f8f8ff" : "#f8f8ff"}
                        ios_backgroundColor="#3e3e3e"
                        onValueChange={() => {
                          let iBorrowerToPay = borrowerToPay;
                          iBorrowerToPay[index]["isSelected"] =
                            !iBorrowerToPay[index]["isSelected"];
                          setBorrowerToPay([...iBorrowerToPay]);
                          iBorrowerToPay.filter((item) => !item.isSelected);
                          let len = iBorrowerToPay.filter(
                              (item) => !item.isSelected
                            ).length,
                            iTotal = (iBorrowerToPay || []).reduce(
                              (acc, item) =>
                                acc + parseFloat(cleanValue(item.amount)),
                              0
                            );
                          setBorrowerToPayAmount(iTotal - len * 30);
                        }}
                        value={row["isSelected"]}
                      />
                    </CustomText>
                  </View>
                </Fragment>
              );
            })}
            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                borderTopWidth: 1,
                borderTopColor: "#999",
                paddingTop: 15,
              }}
            >
              <CustomText style={{ width: "33.3%" }}>Total</CustomText>
              <CustomText style={{ width: "33.3%" }}>
                {formatCurrency(borrowerToPayAmount)}
              </CustomText>
            </View>
          </>
        ),
        isShow: true,
        headerMessage: "Choose Borrowers and Pay",
        footerButton: (
          <>
            <ModalButton
              onPress={(e) => {
                let totalAmount = cleanValue(borrowerToPayAmount);
                if (borrowerToPayAmount == 0) {
                  setProcessingStatus(null);
                  handleAlertMessage("Please choose any borrower to continue.");
                  return;
                } else {
                  let CustIds = borrowerToPay
                    .map((item) => item.CustId)
                    .join(",");
                  setPageCondition({ ...pageConditions, hdnTalxProd: 0 });
                  handleAPI({
                    name: "UpdateBorrForTalx",
                    params: { LoanId: loanId, BorIds: CustIds },
                  })
                    .then((response) => {
                      handleProceedNext();
                    })
                    .catch((err) =>
                      console.error(
                        "Error from UpdateTalxBorrowers ====> ",
                        err
                      )
                    );
                }
                setAlertModalMessage({
                  messageArray: null,
                  isShow: false,
                  headerMessage: null,
                });
              }}
              title={
                <>
                  <CustomText
                    bold={true}
                    style={{ fontSize: 13, color: "#fff" }}
                  >
                    Pay Now
                  </CustomText>
                </>
              }
            />
            <ModalButton
              onPress={(e) => {
                setAlertModalMessage({
                  messageArray: null,
                  isShow: false,
                  headerMessage: null,
                });
              }}
              title={
                <>
                  <CustomText
                    bold={true}
                    style={{ fontSize: web ? 13 : 10, color: "#fff" }}
                  >
                    Cancel
                  </CustomText>
                </>
              }
            />
          </>
        ),
      });
  }, [borrowerToPay]);
  useEffect(() => {
    if ((productDescription || []).length) {
      setProductTotalAmount(
        (productDescription || []).reduce(
          (acc, item) => acc + parseFloat(cleanValue(item.TotalAMount)),
          0
        )
      );
    }
  }, [productDescription]);

  useEffect(() => {
    if (UserId) {
      handleAPI({
        name: "GetCreditDetails", //CMS_SP_GetCreditDetails
        params: { CustId: UserId },
      })
        .then((response) => {
          response = JSON.parse(response)["Table"];
          //console.log(response);
          setCreditCardDetails(
            response.length > 0
              ? {
                  ...response[0],
                  paymentType: 0,
                  // CardNum: 4342343244432,
                  // CardSecurityCode: 1253,
                  // paymentType: 1,
                  ExpMonth: 0,
                  ExpYear: 0,
                  CardType: 0,
                }
              : {}
          );
        })
        .catch((err) =>
          console.error("Error from GetCreditCardDetails ====> ", err)
        );
    }
  }, [UserId]);
  useEffect(() => setIsPaymentDone(isPaid), [isPaid]);
  useEffect(() => {
    if (loanId) {
      handleAPI({
        name: "GetShoppingCartDetails",
        params: { LoanId: loanId, AppraisalOnly: 0, Payor: 3 },
      })
        .then((responseXML) => {
          const responseJSON = JSON.parse(responseXML)["Root"][0]; //new XMLParser().parseFromString(responseXML);
          if (JSON.parse(responseJSON["Status"])?.Status == 1) {
            setProductTotalAmount(cleanValue(responseJSON["AppraisalAmt"]));
            setIsPaid(true);
          } else {
            setIsPaid(false);
          }
          setRawJsonCardDetails(responseJSON);
          let ShoppingCart = JSON.parse(responseJSON["ShoppingCart"] || "[]");
          let iPageConditions = {};
          ShoppingCart.forEach((item) => {
            if (item.ProductCategory == "1") {
              iPageConditions["hdnAppProd"] = 1;
            }
            if (item.ProductID == "21") {
              iPageConditions["hdnFHAProd"] = 1;
            }
            if (item.ProductID == "367") {
              iPageConditions["hdnTalxProd"] = 1;
            }
            if (item.ProductID == "37" || item.ProductID == "370") {
              iPageConditions["isAppPresent"] = 1;
              iPageConditions["reinspectiondate"] = item["reinspectiondate"];
            }
          });
          setPageCondition((prevPageConditions) => {
            return { ...prevPageConditions, ...iPageConditions };
          });

          setProductDescription(ShoppingCart);
          setProcessingStatus(null);
        })
        .catch((err) =>
          console.error("Error from eSign_ShoppingCart_Details ====> ", err)
        );
      handleAPI({
        name: "eSign_Loan_PropertyAddress",
        params: { LoanId: loanId },
      })
        .then((response) => {
          response = (response || "").split(",");
          let [Street, City, State, ZipCode] = response;
          setBorrowerPropertyAddress({ Street, ZipCode, City, State });
        })
        .catch((err) =>
          console.error("Error from eSign_Loan_PropertyAddress ====> ", err)
        );
      handleAPI({
        name: "CheckSession",
        params: { SessionId },
      })
        .then((response) => {
          response = JSON.parse(response)["Table"].reduce((result, session) => {
            result[session.sessionname] = session.sessionvalue;
            return result;
          }, {});
          setPageCondition((prevPageConditions) => {
            return { ...prevPageConditions, ...response };
          });
        })
        .catch((err) => console.error("Error from CheckSession ====> ", err));

      if (UserId) {
        handleAPI({
          name: "GetCreditDetails", //CMS_SP_GetCreditDetails
          params: { CustId: UserId },
        })
          .then((response) => {
            response = JSON.parse(response)["Table"];
            // console.log(response);
            setCreditCardDetails(
              response.length > 0
                ? {
                    ...response[0],
                    paymentType: 0,
                    // CardNum: 4342343244432,
                    // CardSecurityCode: 1253,
                    // paymentType: 1,
                    ExpMonth: 0,
                    ExpYear: 0,
                    CardType: 0,
                  }
                : {}
            );
          })
          .catch((err) =>
            console.error("Error from GetCreditCardDetails ====> ", err)
          );
      }
      handleAPI({
        name: "checkFHACaseNumber",
        params: {
          LoanId: loanId,
        },
      })
        .then((response) => {
          setPageCondition((prevPageConditions) => {
            return { ...prevPageConditions, hdnFhaCase: response };
          });
        })
        .catch((err) =>
          console.error("Error from checkFHACaseNumber ====> ", err)
        );
      handleAPI({
        name: "CheckPackageSigned",
        params: {
          LoanId: loanId,
          RequestId: 3,
          PayorId: 1,
        },
      })
        .then((response) => {
          response = JSON.parse(response)["Response"][0];
          setPageCondition((prevPageConditions) => {
            return { ...prevPageConditions, ...response };
          });
        })
        .catch((err) =>
          console.error("Error from CheckPackageSigned ====> ", err)
        );
    }
  }, [loanId]);
  //============= UseEffect - End ===============//

  //============= Components ===============//
  function CreditCardValidation() {
    try {
      let strMessage = "";
      const {
        CardNum: CardNumber = "",
        paymentType: paymentType = "",
        CardTypeName = "",
        CardType: CardType,
      } = creditCardDetails;

      if (CardNumber === null) CardNumber = "";
      if ((CardNumber || "").match(" ")) {
        strMessage = "Spaces are not allowed in Card Number";
      } else {
        const fLetter = CardNumber.charAt(0);
        if (
          (CardType === 1 && fLetter !== "3") ||
          (CardType === 2 && fLetter !== "4") ||
          (CardType === 3 && fLetter !== "5") ||
          (CardType === 4 && fLetter !== "6")
        ) {
          strMessage = `A ${CardTypeName} card number should begin with the number ${fLetter}.`;
        }
      }
      return strMessage;
    } catch (ex) {
      //alert(ex.message);
    }
  }
  function CardTypeValidation() {
    try {
      var strMessage = "";
      const {
        CardNum: CardNumber,
        paymentType: paymentType,
        CardTypeName = "",
        CardType: CardType,
      } = creditCardDetails;

      var cardLength = CardNumber.length;
      if (CardType == 1 && cardLength != 15) {
        strMessage = `The ${CardTypeName} card number length must be 15 digits.`;
      } else if (CardType === 2 && !(cardLength === 13 || cardLength === 16)) {
        strMessage = `The ${CardTypeName} card number length must be 13 or 16 digits.`;
      } else if (CardType == 3 && cardLength != 16) {
        strMessage = `The ${CardTypeName} card number length must be 16 digits.`;
      }
      if (strMessage != "") return strMessage;
      if (cardLength > 20) {
        strMessage = "The Card Number length cannot be more than 20 digits";
      }
      return strMessage;
    } catch (ex) {}
  }
  function SecurityCodeValidation() {
    try {
      let strMessage = "",
        {
          CardSecurityCode: SecurityCode,
          paymentType: paymentType,
          CardType: CardType,
        } = creditCardDetails,
        SecurityCodeLength = SecurityCode?.toString().length;

      if ((CardType == 2 || CardType == 3) && SecurityCodeLength != 3) {
        strMessage = "Card Security Code should be 3 digits";
      } else if (CardType == 1 && SecurityCodeLength != 4) {
        strMessage = "Card Security Code should be 4 digits";
      }
      return strMessage;
    } catch (ex) {}
  }
  function ValidateMonth() {
    try {
      const { ExpMonth, ExpYear } = creditCardDetails;
      let strMessage = "";
      if (ExpYear != 0) {
        let today = new Date(),
          month = today.getMonth() + 1,
          year = today.getFullYear().toString().substr(2, 2);

        if (
          ExpYear == year &&
          parseInt(ExpMonth) != 0 &&
          parseInt(ExpMonth) < month
        ) {
          strMessage = "Month - The input should not be less than today`s date";
        }
      }
      return strMessage;
    } catch (ex) {
      alert(ex.message);
    }
  }
  const handleAlertMessage = (message) => {
    if (web) {
      alert(message);
    } else {
      Alert.alert(message);
    }
  };
  const handleNextClick = () => {
    let iCreditCardDetailsValidation = [];
    if (
      !(
        pageConditions["hdnAppProd"] === 1 &&
        creditCardDetails["paymentType"] == 2
      )
    ) {
      iCreditCardDetailsValidation = Object.keys(creditCardDetails)
        .map((key) => {
          let value = creditCardDetails[key];

          if (value === "0") value = 0;

          if (
            !value &&
            ![
              "AutoPay",
              "CustID",
              "DefaultCard",
              "ID",
              "NoLongerUse",
              "RejectCode",
              "UserId",
              "Valid",
            ].includes(key)
          ) {
            // log(key, value);
            return key;
          }
        })
        .filter((item) => item);
      setCreditCardDetailsValidation([...iCreditCardDetailsValidation]);
    }

    if (iCreditCardDetailsValidation.length === 0) {
      setAlertMessage({
        message: null,
        isShow: false,
        type: null,
      });
      setProcessingStatus("Next");
      handleNext();
    }
  };
  const handleValidateMessage = (flag) => {
    try {
      let CardNumErrMessage = flag != 3 ? CreditCardValidation() : "",
        CardTypeErrMessage = flag != 3 ? CardTypeValidation() : "",
        SecCodeMessage = SecurityCodeValidation(),
        MonthErrMessage = ValidateMonth(),
        iValidationMessage = [];

      if (CardNumErrMessage) iValidationMessage.push(CardNumErrMessage);
      if (CardTypeErrMessage) iValidationMessage.push(CardTypeErrMessage);
      if (SecCodeMessage) iValidationMessage.push(SecCodeMessage);
      if (MonthErrMessage) iValidationMessage.push(MonthErrMessage);

      if (iValidationMessage.length > 0) {
        setProcessingStatus(null);
        setAlertModalMessage({
          messageArray: iValidationMessage,
          isShow: true,
          headerMessage:
            flag == 0
              ? "Please enter the correct value on the following fields."
              : "Any edit to a credit card requires the card number to be re-input",
        });
        return false;
      }
      return true;
    } catch (ex) {}
  };
  const handleNext = () => {
    let isValid = 1,
      iWarningMessage = "";
    if (
      pageConditions["hdnFHAProd"] == 1 &&
      pageConditions["hdnFhaCase"] === 1
    ) {
      setAlertModalMessage({
        messageArray: (
          <CustomText>
            This loan has a case number assigned to it. Would you like to:
          </CustomText>
        ),
        isShow: true,
        headerMessage: "FHA Case number exists",
        footerButton: (
          <View>
            <View style={{ flexDirection: "row", alignSelf: "flex-end" }}>
              <ModalButton
                onPress={(e) => {
                  setAlertModalMessage({
                    messageArray: null,
                    isShow: false,
                    headerMessage: null,
                  });
                  setPageCondition({ ...pageConditions, hdnFhaCase: 0 });
                  handleNextClick();
                }}
                title={
                  <>
                    <CustomText
                      bold={true}
                      style={{ fontSize: web ? 13 : 10, color: "#fff" }}
                    >
                      Update The Existing Case #
                    </CustomText>
                  </>
                }
              />
              <ModalButton
                onPress={(e) => {
                  setAlertModalMessage({
                    messageArray: null,
                    isShow: false,
                    headerMessage: null,
                  });
                  let url = `../../../BorrowerApplication/Presentation/Webforms/LoanAppTabs.aspx?RemHeadFootr=0&LoanId=${loanId}&CustId=${UserId}&SessionId=${SessionId}&PageName=LoanPropertyInfo&HideNav=1`;
                  if (web) {
                    handleOpenPageURL(url);
                  } else if (!web) {
                    url = url.replace("../../../", REDIRECT_URL);
                    navigation.navigate("Pdf", {
                      url,
                      backTo: "Home",
                      GoToNav: 11,
                      isNeedBack: true,
                    });
                  }
                }}
                title={
                  <>
                    <CustomText
                      bold={true}
                      style={{ fontSize: web ? 13 : 10, color: "#fff" }}
                    >
                      Update The Address
                    </CustomText>
                  </>
                }
              />
              <ModalButton
                onPress={(e) => {
                  setAlertModalMessage({
                    messageArray: null,
                    isShow: false,
                    headerMessage: null,
                  });
                }}
                title={
                  <>
                    <CustomText
                      bold={true}
                      style={{ fontSize: web ? 13 : 10, color: "#fff" }}
                    >
                      Cancel
                    </CustomText>
                  </>
                }
              />
            </View>
            <View
              style={{
                width: !web ? "80%" : 560,
                marginTop: 10,
              }}
            >
              <CustomText>
                * To get a new case number, you must first go to the loan
                application and delete the FHA case number entry.
              </CustomText>
            </View>
          </View>
        ),
      });
      setProcessingStatus(null);
    } else {
      if (
        pageConditions["hdnAppProd"] === 1 &&
        creditCardDetails["paymentType"] == 2
      ) {
        if (
          pageConditions["IsAppPresent"] === 1 &&
          productDescription.length == 1
        ) {
          isValid = 1;
        } else if (
          creditCardDetails["paymentType"] == 2 &&
          productDescription.length >= 2
        ) {
          iWarningMessage =
            "One of the products selected is not available for a credit line option. Please change the payment type, or only process payment for 1 product at a time.";
          isValid = 0;
        } else {
          iWarningMessage =
            "Appraisal products cannot be ordered using the DMC Credit Line payment method.";
          isValid = 0;
        }
        setAlertMessage({
          message: iWarningMessage,
          isShow: true,
          type: "danger",
        });
      }

      if (isValid === 1) {
        handleProceedNext();
      } else {
        setProcessingStatus(null);
      }
    }
  };
  const handleValidateContinue = () => {
    handleAPI({
      name: "AddressValidation_WebserviceCall", //change
      params: { LoanId: loanId, SessionId, CustId: 0, EmpNum: UserId },
    })
      .then((response) => {
        let array = response.split("~")?.map((item) => item.trim()),
          [valid, returnText] = array;
        handleUSPSCheckAddressValid(valid, returnText, array); //fnUSPSCheckAddressValid(0, 'Address Not Found.', ["0","Address Not Found.","","","",""])
      })
      .catch((err) =>
        console.error("Error from AddressValidation ====> ", err)
      );
  };
  const handleSaveUspsAddress = (street, state, city, zip, flag) => {
    handleAPI({
      name: "Save_UspsAddressdetails",
      params: {
        LoanId: loanId,
        address: street,
        state,
        city,
        zip,
        flag,
        SessionId,
      },
    })
      .then((response) => {
        setBorrowerPropertyAddress({
          Street: street,
          ZipCode: zip,
          City: city,
          State: state,
        });
      })
      .catch((err) => console.error("Error from SaveUspsAddress ====> ", err));
  };
  const handleSavePropertyInfo = () => {
    try {
      const { Street, ZipCode, City, State } = borrowerPropertyAddress,
        Row = `<row FieldId="42" SelectedVal="${Street}"/>
          <row FieldId="46" SelectedVal="${ZipCode}"/>
          <row FieldId="44" SelectedVal="${State}"/>
          <row FieldId="43" SelectedVal="${City}"/>`,
        strXmlIn = `<root><PropertyInfo>${Row}</PropertyInfo></root>`;

      handleAPI({
        name: "UpdatePropertyInfo",
        params: { LoanId: loanId, strXmlIn },
      })
        .then((response) => {})
        .catch((err) =>
          console.error("Error from UpdatePropertyInfo ====> ", err)
        );
    } catch (e) {
      alert("fnSavePropertyInfo()" + e.message);
    }
  };

  const onMessage = async (event) => {
    const { type, base64 } = JSON.parse(event.nativeEvent.data);
    if (base64 && type === "base64" && !__DEV__) {
      shareHtmlContent(base64, (status) => {});
    }
  };
  const setFrameHeight = () => {
    const iFrameHeight = document.querySelector(".frame.card.container");
    if (iFrameHeight || true) {
      const styleElement = document.createElement("style");
      styleElement.innerHTML = `
      #webIframe {min-height: ${
        (1024 || iFrameHeight.scrollHeight) + 150
      }px !important
      }
      .frame.card.container{
      margin:0 !important;
      padding:0 10px !important;
      width:100% !important;
      }
      `;
      document.head.appendChild(styleElement);
    } else {
      setTimeout(() => {
        setFrameHeight();
      }, 200);
    }
  };

  const handleUSPSCheckAddressValid = (isValid, returnMessage, details) => {
    if (isValid == 1) {
      let [valid, street = "", zip = "", city = "", state = ""] = details;
      handleAPI({
        name: "USPS_AddressValidation",
        params: { LoanId: loanId, EmpNum: UserId },
      })
        .then((response) => {
          response = new XMLParser().parseFromString(response);
          let addressArray = response["children"].filter(
              (item) => item["name"] === "address"
            ),
            addressObj =
              addressArray.length > 0
                ? response["children"].filter(
                    (item) => item["name"] === "address"
                  )[0]["children"][0]["attributes"]
                : {};
          let {
            Street = "",
            City = "",
            Zip = "",
            State = "",
            ValidAddress = 0,
          } = addressObj;
          if (street != Street || city != City || zip != Zip) {
            setAlertModalMessage({
              messageArray: (
                <View
                  style={{
                    flexDirection: web ? "row" : "column",
                    justifyContent: "space-between",
                  }}
                >
                  <AccordionItem
                    title="Existing Address:"
                    isExpand={true}
                    isAccordion={false}
                    style={{ width: web ? "48%" : "100%" }}
                  >
                    <>
                      <Separator />
                      <InputBox
                        disabled={true}
                        label="Property Address"
                        placeholder="Property Address"
                        value={Street}
                      />
                      <InputBox
                        disabled={true}
                        label="Zip Code"
                        placeholder="Zip Code"
                        value={Zip}
                        keyboardType="numeric"
                      />
                      <InputBox
                        disabled={true}
                        label="City"
                        placeholder="City"
                        value={City}
                      />
                      <InputBox
                        disabled={true}
                        label="State"
                        placeholder="State"
                        value={State}
                      />
                      <ModalButton
                        onPress={(e) => {
                          handleSaveUspsAddress(street, state, city, zip, 0);
                        }}
                        title={
                          <>
                            <Icon size={15} name="check" color={"#fff"} />
                            <CustomText
                              bold={true}
                              style={{
                                fontSize: web ? 13 : 10,
                                color: "#fff",
                                marginLeft: 5,
                              }}
                            >
                              Use this Address
                            </CustomText>
                          </>
                        }
                      />
                    </>
                  </AccordionItem>
                  <AccordionItem
                    title="Address from Verification Agency:"
                    isExpand={true}
                    isAccordion={false}
                    style={{ width: web ? "48%" : "100%" }}
                  >
                    <>
                      <Separator />
                      <InputBox
                        disabled={true}
                        label="Property Address"
                        placeholder="Property Address"
                        value={street}
                      />
                      <InputBox
                        disabled={true}
                        label="Zip Code"
                        placeholder="Zip Code"
                        value={zip}
                        keyboardType="numeric"
                      />
                      <InputBox
                        disabled={true}
                        label="City"
                        placeholder="City"
                        value={city}
                      />
                      <InputBox
                        disabled={true}
                        label="State"
                        placeholder="State"
                        value={state}
                      />
                      <ModalButton
                        onPress={(e) => {
                          handleSaveUspsAddress(street, state, city, zip, 0);
                        }}
                        title={
                          <>
                            <Icon size={15} name="check" color={"#fff"} />
                            <CustomText
                              bold={true}
                              style={{
                                fontSize: web ? 13 : 10,
                                color: "#fff",
                                marginLeft: 5,
                              }}
                            >
                              Use this Address
                            </CustomText>
                          </>
                        }
                      />
                    </>
                  </AccordionItem>
                </View>
              ),
              isShow: true,
              headerMessage: "Address Confirmation",
              footerButton: (
                <View>
                  <View style={{ flexDirection: "row", alignSelf: "flex-end" }}>
                    <ModalButton
                      onPress={(e) => {
                        setAlertModalMessage({
                          messageArray: null,
                          isShow: false,
                          headerMessage: null,
                        });
                      }}
                      title={
                        <>
                          <Icon size={15} name={"close"} color={"#fff"} />
                          <CustomText
                            bold={true}
                            style={{
                              fontSize: web ? 13 : 10,
                              color: "#fff",
                              marginLeft: 5,
                            }}
                          >
                            Don't Validate Now
                          </CustomText>
                        </>
                      }
                    />
                  </View>
                  {!web && (
                    <>
                      <Separator />
                      <Separator />
                      <Separator />
                    </>
                  )}
                </View>
              ),
            });
          } else if (ValidAddress != 1) {
            handleSaveUspsAddress(street, state, city, zip, 0);
          }
        })
        .catch((err) =>
          console.error("Error from USPS_AddressValidation ====> ", err)
        );
    } else if (isValid == 0) {
      setAlertModalMessage({
        messageArray: (
          <>
            <View style={{ marginLeft: web ? 10 : 1 }}>
              <View
                style={[
                  styles.tableRow,
                  {
                    backgroundColor: "#307ecc",
                    paddingVertical: 8,
                    borderBottomWidth: 1,
                  },
                ]}
              >
                {[
                  "Select",
                  "Property Address",
                  "Zip Code",
                  "City",
                  "State",
                ].map((head, index) => {
                  return (
                    <CustomText
                      bold={true}
                      style={[
                        styles.cell,
                        {
                          color: "#fff",
                        },
                        index === 0
                          ? {
                              maxWidth: web ? 215 : 35,
                              minWidth: web ? 215 : 35,
                            }
                          : {},
                      ]}
                    >
                      {head}
                    </CustomText>
                  );
                })}
              </View>
              <View style={[styles.tableRow, { paddingHorizontal: 0 }]}>
                {[
                  <ModalButton
                    onPress={(e) => {
                      handleAPI({
                        name: "ValidateNewConstructionAddress",
                        params: {
                          LoanId: loanId,
                          EmpNum: UserId,
                          SessionId,
                        },
                      })
                        .then((response) => {
                          setBorrowerPropertyAddress({
                            Street: street,
                            ZipCode: zip,
                            City: city,
                            State: state,
                          });
                        })
                        .catch((err) =>
                          console.error(
                            "Error from SaveUspsAddress ====> ",
                            err
                          )
                        );
                      setAlertModalMessage({
                        messageArray: null,
                        isShow: false,
                        headerMessage: null,
                      });
                    }}
                    style={{ margin: 0, marginRight: 5 }}
                    title={
                      <>
                        <CustomText
                          bold={true}
                          style={{
                            fontSize: web ? 11 : 7,
                            color: "#fff",
                            padding: 5,
                          }}
                        >
                          Use This Address
                        </CustomText>
                      </>
                    }
                  />,
                  borrowerPropertyAddress["Street"],
                  borrowerPropertyAddress["ZipCode"],
                  borrowerPropertyAddress["City"],
                  borrowerPropertyAddress["State"],
                ].map((cell, index) => {
                  return (
                    <CustomText
                      style={[
                        styles.cell,
                        index === 0
                          ? {
                              margin: 0,
                              width: web ? 215 : 35,
                            }
                          : {},
                      ]}
                    >
                      {cell}
                    </CustomText>
                  );
                })}
              </View>
            </View>
          </>
        ),
        isShow: true,
        headerMessage: "Validate address and continue",
        footerButton: (
          <View>
            <View style={{ flexDirection: "row", alignSelf: "flex-end" }}>
              <ModalButton
                onPress={(e) => {
                  setAlertModalMessage({
                    messageArray: null,
                    isShow: false,
                    headerMessage: null,
                  });
                }}
                title={
                  <>
                    <Icon size={15} name={"close"} color={"#fff"} />
                    <CustomText
                      bold={true}
                      style={{
                        fontSize: web ? 13 : 10,
                        color: "#fff",
                        marginLeft: 5,
                      }}
                    >
                      Don't Validate Now
                    </CustomText>
                  </>
                }
              />
            </View>
          </View>
        ),
      });
    }
  };
  const handleAddressValidation = () => {
    setAlertModalMessage({
      messageArray: (
        <CustomText>
          This product requires a property address validation. Would you like to
          do that now?
        </CustomText>
      ),
      isShow: true,
      headerMessage: "Validate address and continue",
      footerButton: (
        <View>
          <View style={{ flexDirection: "row", alignSelf: "flex-end" }}>
            <ModalButton
              onPress={(e) => {
                setAlertModalMessage({
                  messageArray: null,
                  isShow: false,
                  headerMessage: null,
                });
              }}
              title={
                <>
                  <CustomText
                    bold={true}
                    style={{ fontSize: web ? 13 : 10, color: "#fff" }}
                  >
                    Cancel
                  </CustomText>
                </>
              }
            />
            <ModalButton
              onPress={(e) => {
                setAlertModalMessage({
                  messageArray: null,
                  isShow: false,
                  headerMessage: null,
                });
                handleValidateContinue();
              }}
              title={
                <>
                  <CustomText
                    bold={true}
                    style={{ fontSize: web ? 13 : 10, color: "#fff" }}
                  >
                    Validate and Continue
                  </CustomText>
                </>
              }
            />
          </View>
        </View>
      ),
    });
  };
  const handleProceedNext = async () => {
    let isProceed = true,
      strFieldId = "",
      selectedID = [],
      creditReportOrder = 0,
      NotCreditReport = 0,
      index,
      IsAddressValid;
    isProceed = handleValidateMessage();

    let CardId = 0;
    if (isProceed) {
      if (creditCardDetails["paymentType"] == 1) {
        CardId = await handleUpdateCardDetails();
      }
    } else {
      setProcessingStatus(null);
      return;
    }
    productDescription.forEach(async (product, index) => {
      let { Amount, productcategory, ID } = product;
      if (productcategory == 7 && Amount != "0.00" && Amount != "")
        creditReportOrder++;
      else NotCreditReport++;
      selectedID.push(ID);

      if (ID == "21") {
        IsAddressValid = await handleValidateAddress(loanId);
        if (IsAddressValid == 0) {
          handleAlertMessage(
            "The property address must be validated before an FHA Case Number is ordered."
          );
          let url = `../../../BorrowerApplication/Presentation/Webforms/addressValidation.asp?SessionID=${SessionId}&LoanID=${LoanId}`;
          if (web) {
            handleOpenPageURL(url);
          } else if (!web) {
            url = url.replace("../../../", REDIRECT_URL);
            navigation.navigate("Pdf", {
              url,
              backTo: "Home",
              GoToNav: 11,
              isNeedBack: true,
            });
          }
        }
      }
    });
    SetSelectedFeeId(selectedID);
    if (IsAddressValid == 0) return false;

    if (pageConditions["hdnTalxProd"] === 1) {
      handleCheckTalxBorrowers();
      return;
    }
    if (selectedID.length == 0) {
      setProcessingStatus(null);
      handleAlertMessage("No shopping cart product selected.");
      return;
    }

    let isAddressReq = await handleGetAddressValidReqProducts(
      selectedID.join(","),
      loanId
    );
    if (isAddressReq == 999 && IsAddressValid == 999) {
      handleAddressValidation();
    } else {
      let {
        intRequestType,
        iPayor,
        compnum = 0,
        empnum = 0,
        CustId = 0,
      } = pageConditions;
      let intCompNum = 0,
        intUserId = UserId || empnum,
        intCustId = CustId || 0,
        ccPayorID = CardId || 0, // CardId needs to passed in this variable
        iRequestType = intRequestType,
        intWhoPaid = 0;

      intCompNum = compnum;

      let totalAmount =
        (
          productTotalAmount?.toString().replace(/[^0-9.-]/g, "") || ""
        ).trim() || 0;

      if (iRequestType == 2) intWhoPaid = intUserId;
      else if (iRequestType == 3) intWhoPaid = intCustId;
      else intWhoPaid = intUserId;

      let { Proceed, DateExceed, PackageExists, Signed } = pageConditions;

      let blSigned = "1" || Signed,
        blProceed = Proceed,
        blDate = DateExceed,
        blPackageExists = PackageExists,
        strDetails =
          '<request LoanId="' +
          loanId +
          '" RequestType="' +
          iRequestType +
          '" Payor="1"></request>',
        sType = 3,
        checked = sType === 3;

      try {
        if (
          creditReportOrder != 0 &&
          NotCreditReport != 0 &&
          blPackageExists == 0
        ) {
          handleAlertMessage(
            "You can only pay for the Credit Report since an eSign package has to be generated and sent to the borrower(s). ."
          );

          setProcessingStatus(null);
          return;
        } else if (
          creditReportOrder != 0 &&
          NotCreditReport != 0 &&
          blPackageExists != 0 &&
          blSigned == 0 &&
          blDate == 0
        ) {
          if (totalAmount != "0.00" && totalAmount != "") {
            if (PackageExists == 0 && TotalAmount != 0) {
              handleAlertMessage(
                "There has been no eSign package generated. To pay for products an eSign package has to be generated and sent to the borrower(s)."
              );
              setProcessingStatus(null);
              return;
            } else if (Proceed == 1 && Date == 0 && blSigned == 0) {
              handleAlertMessage(
                "Payment before Early Disclosures are received by the borrower is not permitted. You can pay only after 3 business days from the date the disclosures were sent to the borrower, or after the borrower signs the disclosures, whichever is sooner."
              );
              setProcessingStatus(null);
              return;
            } else if (Proceed == 0 && Date == 0 && blSigned == 0) {
              handleAlertMessage(
                "Payment before Early Disclosures are received by the borrower is not permitted. You can pay only after 3 business days from the date the disclosures were sent to the borrower, or after the borrower signs the disclosures, whichever is sooner."
              );
              setProcessingStatus(null);
              return;
            }
          }
        } else if (creditReportOrder == 0 && blSigned == 0 && blDate == 0) {
          if (totalAmount != "0.00" && totalAmount != "") {
            if (blPackageExists == 0 && totalAmount != 0) {
              handleAlertMessage(
                "There has been no eSign package generated. To pay for products an eSign package has to be generated and sent to the borrower(s)."
              );
              setProcessingStatus(null);
              return;
            } else if (Proceed == 1 && Date == 0 && Signed == 0) {
              handleAlertMessage(
                "Payment before Early Disclosures are received by the borrower is not permitted. You can pay only after 3 business days from the date the disclosures were sent to the borrower, or after the borrower signs the disclosures, whichever is sooner."
              );
              setProcessingStatus(null);
              return;
            } else if (Proceed == 0 && Date == 0 && Signed == 0) {
              handleAlertMessage(
                "Payment before Early Disclosures are received by the borrower is not permitted. You can pay only after 3 business days from the date the disclosures were sent to the borrower, or after the borrower signs the disclosures, whichever is sooner."
              );
              setProcessingStatus(null);
              return;
            }
          }
        } else {
          if (
            creditReportOrder != 0 &&
            NotCreditReport != 0 &&
            blPackageExists == 0
          ) {
            handleAlertMessage(
              "You can only pay for the Credit Report since an eSign package has to be generated and sent to the borrower(s). ."
            );
            setProcessingStatus(null);
            return;
          } else if (
            creditReportOrder != 0 &&
            NotCreditReport != 0 &&
            blPackageExists != 0 &&
            blSigned == 0 &&
            blDate == 0
          ) {
            if (blPackageExists == 0 && TotalAmount != 0) {
              handleAlertMessage(
                "There has been no eSign package generated. To pay for products an eSign package has to be generated and sent to the borrower(s)."
              );
              setProcessingStatus(null);
              return;
            } else if (blProceed == 1 && Date == 0 && blSigned == 0) {
              handleAlertMessage(
                "Payment before Early Disclosures are received by the borrower is not permitted. You can pay only after 3 business days from the date the disclosures were sent to the borrower, or after the borrower signs the disclosures, whichever is sooner."
              );
              setProcessingStatus(null);
              return;
            } else if (blProceed == 0 && Date == 0 && blSigned == 0) {
              handleAlertMessage(
                "Payment before Early Disclosures are received by the borrower is not permitted. You can pay only after 3 business days from the date the disclosures were sent to the borrower, or after the borrower signs the disclosures, whichever is sooner."
              );
              setProcessingStatus(null);
              return;
            }
          } else if (
            totalAmount != ".00" &&
            totalAmount != "0" &&
            totalAmount != "" &&
            totalAmount != "0.00"
          ) {
            if (blPackageExists == 0 && blDate == 0) {
              setAlertMessage({
                message:
                  "Before loan products can be ordered, Early Disclosures (via eSign) must be delivered to the borrower. Please try again after the eSignatures are completed",
                isShow: true,
                type: "danger",
              });
              setProcessingStatus(null);
              return;
            } else if (blProceed == 1 && blDate == 0 && blSigned == 0) {
              if (
                totalAmount != ".00" &&
                totalAmount != "0" &&
                totalAmount != "" &&
                totalAmount != "0.00"
              ) {
                setAlertMessage({
                  message:
                    "Before loan products can be ordered, Early Disclosures (via eSign) must be delivered to the borrower. Please try again after the eSignatures are completed",
                  isShow: true,
                  type: "danger",
                });
                setProcessingStatus(null);
                return;
              }
            } else if (blProceed == 0 && blDate == 0 && blSigned == 0) {
              if (
                totalAmount != ".00" &&
                totalAmount != "0" &&
                totalAmount != "" &&
                totalAmount != "0.00"
              ) {
                setAlertMessage({
                  message:
                    "Before loan products can be ordered, Early Disclosures (via eSign) must be delivered to the borrower. Please try again after the eSignatures are completed",
                  isShow: true,
                  type: "danger",
                });
                setProcessingStatus(null);
                return;
              }
            }
          }
        }
      } catch (err) {
        setAlertMessage({
          message: err.message,
          isShow: true,
          type: "danger",
        });
        setProcessingStatus(null);
        return;
      }

      const retReinspecDate = pageConditions["reinspectiondate"] || "",
        {
          payeeEmail = pageConditions["EmailOutside"] || "",
          FirstName,
          LastName,
          CardEmail,
        } = creditCardDetails,
        TaskId = "",
        LinkType = "OrderAppraisal",
        CIPhone1 = "",
        CIEmailAddress = CardEmail || pageConditions["EmailOutside"] || ""; //get form CMSOS_SP_FETCHBORROWERS_ShoppingCart
      const PaymentInfo = `<totalAmount>${totalAmount}</totalAmount><iRequestType>${iRequestType}</iRequestType><intCompNum>${intCompNum}</intCompNum><intUserId>${intUserId}</intUserId><intCustId>${intCustId}</intCustId><ccPayorID>${ccPayorID}</ccPayorID><dblFee>${totalAmount}</dblFee><selectedID>${selectedID}</selectedID><intWhoPaid>${intWhoPaid}</intWhoPaid><payeeEmail>${payeeEmail}</payeeEmail><TaskId>${TaskId}</TaskId><LinkType>${LinkType}</LinkType><FirstName>${FirstName}</FirstName><LastName>${LastName}</LastName><CIPhone1>${CIPhone1}</CIPhone1><CIPhone2>${""}</CIPhone2><Reinspectiondate>${retReinspecDate}</Reinspectiondate><CIEmailAddress>${CIEmailAddress}</CIEmailAddress>`;

      const XMLin = `<root><PaymentInfo>${PaymentInfo}</PaymentInfo></root>`;
      // setIsPaid(true);
      // setProcessingStatus(null);
      // return;

      handleAPI({
        name: "Esgin_ShoppingCartProcessPayment",
        params: { LoanId: loanId, SessionId: SessionId, XMLin: XMLin },
      })
        .then((response) => {
          // response = JSON.parse(response);

          setProcessingStatus(null);
          if (response) {
            setAlertMessage({
              message: response,
              isShow: true,
              type: "danger",
            });
            setProcessingStatus(null);
            return;
          }
          if (
            totalAmount == ".00" ||
            totalAmount == "0" ||
            totalAmount == "" ||
            totalAmount == "0.00"
          ) {
            setAlertMessage({
              message: "Thank you. Your order has been placed successfully.",
              isShow: true,
              type: "success",
            });
            setProcessingStatus(null);
          } else {
            if (sType == "3") {
              setAlertMessage({
                message:
                  "Thank you. Your credit card payment has been processed." +
                  payeeEmail,
                isShow: true,
                type: "success",
              });
              setProcessingStatus(null);
            } else {
              setAlertMessage({
                message:
                  "Thank you. Your credit card payment has been processed." +
                  payeeEmail,
                isShow: true,
                type: "success",
              });
              setProcessingStatus(null);
            }
          }
          setIsPaid(true);
          // GetEsignCompletedTransaction(0);// No need for borrower - sType is 3
        })
        .catch((err) =>
          console.error("Error from CheckAddressValidity ====> ", err)
        );
    }
  };
  const handleGetAddressValidReqProducts = async (selectedID, iLoanId) => {
    return await handleAPI({
      name: "GetAddressValidReqProducts",
      params: { LoanId: iLoanId || loanId, GroupIds: selectedID },
    })
      .then((response) => {
        return response;
      })
      .catch((err) =>
        console.error("Error from CheckAddressValidity ====> ", err)
      );
  };
  // useEffect(() => {
  //   console.log("alertModalMessage", alertModalMessage);
  // }, [alertModalMessage]);

  const handleCheckTalxBorrowers = () => {
    handleAPI({
      name: "GetPaymentBorrDet",
      params: { LoanId: loanId },
    })
      .then((response) => {
        response = JSON.parse(response)["Table"];
        if (response.length > 1) {
          response.forEach((item) => (item.isSelected = true));
          setBorrowerToPay(response);
          let iTotal = (response || []).reduce(
            (acc, item) => acc + parseFloat(cleanValue(item.amount)),
            0
          );
          setBorrowerToPayAmount(iTotal);
          setProcessingStatus(null);
        } else {
          setPageCondition({ ...pageConditions, hdnTalxProd: 0 });
          handleAPI({
            name: "UpdateBorrForTalx",
            params: { LoanId: loanId, BorIds: response[0]["CustId"] },
          })
            .then((response) => {
              handleProceedNext();
            })
            .catch((err) =>
              console.error("Error from UpdateTalxBorrowers ====> ", err)
            );
        }
      })
      .catch((err) => console.error("Error from GetBorrDet ====> ", err));
  };
  const handleValidateAddress = async (LoanId) => {
    return await handleAPI({
      name: "CheckAddressValidity",
      params: { LoanId: LoanId || loanId },
    })
      .then((response) => {
        return response;
      })
      .catch((err) =>
        console.error("Error from CheckAddressValidity ====> ", err)
      );
  };

  function ValidateCardType(iCardNumber) {
    let CardNumber = iCardNumber || creditCardDetails["CardNum"],
      returnValue = 0;

    if (String(CardNumber).substring(0, 1) == 3) returnValue = 1;
    else if (String(CardNumber).substring(0, 1) == 4) returnValue = 2;
    else if (String(CardNumber).substring(0, 1) == 5) returnValue = 3;
    else if (String(CardNumber).substring(0, 1) == 6) returnValue = 4;

    return returnValue;
  }
  const handleUpdateCardDetails = async () => {
    const {
        FirstName,
        LastName,
        Address,
        City,
        State,
        CardNum,
        ExpMonth,
        ExpYear,
        ZipCode,
        CardSecurityCode,
        CardType,
        CardEmail,
      } = creditCardDetails,
      { intRequestType } = pageConditions;

    return await handleAPI({
      name: "UpdateCreditCardDetails",
      params: {
        Id: UserId,
        FirstName,
        LastName,
        Address,
        City,
        State,
        Zipcode: ZipCode,
        CardNum,
        ExpMonth,
        ExpYear,
        CardSecurityCode,
        NoLongerUse: 1,
        RequestType: intRequestType,
        CustId: UserId,
        CardType,
        Email: CardEmail,
      },
    })
      .then((response) => {
        return response;
      })
      .catch((err) =>
        console.error("Error from eSign_Check_PackageSigned ====> ", err)
      );
  };
  const ProductDescription = () => {
    return (
      <>
        {productDescription?.length > 0 ? (
          <>
            {productDescription.map((productRow, index) => {
              return (
                <Fragment key={index}>
                  <View style={styles.productRow}>
                    <View style={[styles.productCell, { width: `70%` }]}>
                      <CustomText style={[styles.productTitle]} bold={true}>
                        Product Description
                      </CustomText>
                      <CustomText
                        style={[styles["productName"]]}
                        bold={true}
                        onPress={() =>
                          Linking.openURL(productRow["ProductURL"])
                        }
                      >
                        {productRow["ProductDesc"]}
                      </CustomText>
                    </View>
                    <View style={[styles.productCell, { width: `30%` }]}>
                      <CustomText
                        style={[styles.productTitle, { fontSize: 11 }]}
                        bold={true}
                      >
                        Product Amount
                      </CustomText>
                      <CustomText style={[styles["productAmount"]]} bold={true}>
                        {formatCurrency(productRow["TotalAMount"])}
                      </CustomText>
                    </View>
                  </View>
                </Fragment>
              );
            })}
            {productDescription.length > 0 && (
              <View style={{ alignItems: "flex-end" }}>
                <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
                  {
                    <>
                      <CustomText
                        style={[
                          styles.productTitle,
                          { fontSize: 11, paddingHorizontal: 10 },
                        ]}
                        bold={true}
                      >
                        Total
                      </CustomText>
                      <CustomText style={[styles["productAmount"]]} bold={true}>
                        {formatCurrency(productTotalAmount)}
                      </CustomText>
                    </>
                  }
                </View>
              </View>
            )}
          </>
        ) : productDescription?.length == 0 ? (
          <>
            <CustomText bold={true}>
              <FontAwesome
                name="check"
                size={18}
                color="green"
                style={{ marginRight: 5 }}
              />
              There are no products to pay for, or all payments have been
              processed.
            </CustomText>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };
  const BorrowerDetails = () => {
    return (
      <View>
        <Separator />
        <View style={{}}>
          <CustomText style={[styles.borrowerTitle]} bold={true}>
            Property Information
          </CustomText>
          {Object.keys(borrowerPropertyAddress).length > 0 && (
            <>
              <CustomText>{borrowerPropertyAddress["Street"]}</CustomText>
              <CustomText>{`${borrowerPropertyAddress["City"]},${borrowerPropertyAddress["State"]} ${borrowerPropertyAddress["ZipCode"]}`}</CustomText>
            </>
          )}
        </View>

        <View style={[styles.row, { marginTop: 6 }]}>
          <CustomText style={[styles.borrowerTitle]}>
            <CustomText bold={true}>Loan ID:</CustomText> {loanId}
          </CustomText>
        </View>
      </View>
    );
  };
  const handleChangeText = (name, value) => {
    let valueObj = { [name]: value };
    if (name === "paymentType")
      valueObj = { [name]: value["value"], CardTypeName: value["label"] };
    else if (name === "CardNum") {
      valueObj = {
        [name]: value,
        CardType: ValidateCardType(value),
      };
    }

    setCreditCardDetails((prevCreditCardDetails) => {
      return { ...prevCreditCardDetails, ...valueObj };
    });
  };
  const ModalButton = ({
    onPress,
    bold = true,
    title,
    style = {},
    textStyle = {},
  }) => (
    <TouchableOpacity
      activeOpacity={1}
      onPress={onPress}
      style={[
        styles.buttonContainer,
        {
          borderRadius: 5,
          paddingVertical: 6,
          marginLeft: 8,
          height: web ? 35 : 30,
        },
        style,
      ]}
    >
      <CustomText style={{ ...{ color: "#fff" }, ...textStyle }} bold={bold}>
        {title}
      </CustomText>
    </TouchableOpacity>
  );
  //============= Components - End ===============//
  return (
    <>
      <View
        onLayout={(event) => {
          if (!web) {
            let layout = event.nativeEvent.layout;
            setTopEdge((prev) => {
              return {
                ...prev,
                contentWrapperY: layout.y,
                contentWrapperHeight: layout.height,
              };
            });
          }
        }}
        pointerEvents={"auto"}
        style={[
          styles.container,
          isSmallScreen && web ? { alignItems: "center" } : {},
        ]}
      >
        {processingStatus === "pageLoading" ? (
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                height: web ? 22 : 16,
                width: web ? 22 : 16,
              }}
            >
              <ArrowSpinner
                isSpinner={true}
                size={web ? 22 : 16}
                color="#376596"
                style={{
                  top: !web ? 4 : 0,
                }}
              />
            </View>
            <CustomText bold> Loading...</CustomText>
          </View>
        ) : (
          <ScrollContainer style={{ width: "100%" }}>
            <View>
              {isPaid ? (
                <>
                  {processingStatus === "showReceipt" ? (
                    <>
                      <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => setProcessingStatus(null)}
                      >
                        <CustomText
                          bold={true}
                          style={{ paddingVertical: 10, paddingHorizontal: 10 }}
                        >
                          <Icon name="angle-left" size={16} /> Back
                        </CustomText>
                      </TouchableOpacity>
                      <WebPageView
                        url={`../../../BorrowerApplication/Presentation/Webforms/PaymentReceiptNew.htm?LoanId=${loanId}&OrderId=${
                          rawJsonCardDetails["orderId"]
                        }&from=GoDirect&fType=${web ? "w" : "m"}`}
                        // onLoad={setFrameHeight}
                        onMessage={onMessage}
                        from="AppraisalPayment"
                        injectedJavaScript={`
                              (function() {
                                function sendHeight() {
                                  const height = document.documentElement.scrollHeight || document.body.scrollHeight;
                                  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'height', height }));
                                }
                                setTimeout(sendHeight, 100);
                                window.addEventListener('resize', sendHeight);
                              })();

                              (function() {
                                const iDocument = document.documentElement || document.body;
                                const divWrapper = iDocument.querySelector('.div-wrapper');

                                if (divWrapper) {
                                    divWrapper.removeAttribute('onclick');
                                    divWrapper.addEventListener('click', async () => {
                                      try {
                                            imageFrame.style.display=''
                                            const base64Pdf = await document.getElementById('imageFrame').contentWindow.getBase64()
                                            imageFrame.style.display='none'
                                            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'base64', base64: base64Pdf }));
                                          } catch (error) {
                                            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'error', error: error.message }));
                                          }
                                    });
                                }
                              })();
                            `}
                      />
                    </>
                  ) : (
                    <>
                      <Separator />
                      <View>
                        <CustomText
                          style={{ fontSize: web ? 24 : 20 }}
                          bold={true}
                        >{`Thank you. Your payment has been processed. 

A payment for ${formatCurrency(
                          productTotalAmount
                        )} will appear from Direct Services LLC on your bank statement.

`}</CustomText>

                        <View
                          style={{
                            flexDirection: "row",
                            width: web ? 170 : 150,
                          }}
                        >
                          <CustomText
                            onPress={() => {
                              setProcessingStatus("showReceipt");
                              return;
                              if (processingStatus !== "DownloadReceipt") {
                                setProcessingStatus("DownloadReceipt");
                                handleAPI({
                                  name: "GetPaymentReceipts",
                                  params: {
                                    LoanId: loanId,
                                    selectedFeeId: selectedFeeId?.join(","),
                                  },
                                })
                                  .then((response) => {
                                    try {
                                      let url =
                                        JSON.parse(response)["Table"][0][
                                          "ImagePath"
                                        ]; //JSON.parse(response);

                                      url = url.replace(
                                        "../../../",
                                        REDIRECT_URL
                                      );

                                      if (web) {
                                        window.open(
                                          url,
                                          "_blank",
                                          "width=750,height=780,resizable=1,scrollbars=1"
                                        );
                                      } else {
                                        navigation.navigate("Pdf", {
                                          url,
                                          backTo: "Home",
                                          GoToNav: 11,
                                          isNeedBack: true,
                                        });
                                      }
                                      setProcessingStatus(null);
                                    } catch (e) {
                                      console.error(
                                        "Error form GetPaymentReceipts ====> ",
                                        e
                                      );
                                    }
                                  })
                                  .catch((err) =>
                                    console.error(
                                      "Error from GetPaymentReceipts ====> ",
                                      err
                                    )
                                  );
                              }
                            }}
                            style={{
                              ...{
                                fontSize: 16,
                                color: "#1172c1",
                                marginRight: 10,
                              },
                              ...(web ? { cursor: "pointer" } : {}),
                              ...(processingStatus == "DownloadReceipt"
                                ? {
                                    opacity: 0.5,
                                  }
                                : {}),
                            }}
                          >
                            Download Receipt
                          </CustomText>
                          {processingStatus === "DownloadReceipt" && (
                            <View
                              style={{
                                marginTop: 7,
                              }}
                            >
                              <ArrowSpinner isSpinner={true} size={15} />
                            </View>
                          )}
                        </View>
                      </View>
                      <Separator />
                      <Separator />
                    </>
                  )}
                </>
              ) : (
                <View style={{ width: "100%" }}>
                  <Title text="Pay for Appraisal" />
                  <AccordionItem
                    title="Product Description"
                    isExpand={true}
                    isAccordion={false}
                  >
                    <ProductDescription />
                    <BorrowerDetails />
                  </AccordionItem>
                  <AccordionItem
                    title="Enter Credit Card Information"
                    isExpand={true}
                    isAccordion={false}
                  >
                    <>
                      {(showWarning || pageConditions["Proceed"] == 0) && (
                        <View
                          style={{
                            backgroundColor: "#fcf8e3",
                            borderWidth: 1,
                            borderColor: "#faebcc",
                            padding: 10,
                            flexDirection: "row",
                          }}
                        >
                          <CustomText style={{ color: "#8a6d3b" }}>
                            You cannot order an appraisal until all borrowers
                            authorize their intent to proceed by completing
                            their Initial Disclosure eSign process.
                          </CustomText>
                          {/* <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => {
                          setShowWarning(false);
                        }}
                      >
                        <Icon
                          name="close"
                          size={14}
                          color="#8a6d3b"
                          style={{ opacity: 0.5 }}
                        />
                      </TouchableOpacity> */}
                        </View>
                      )}
                      <View style={{ height: 20 }}></View>
                      <Dropdown
                        isValid={creditCardDetailsValidation.includes(
                          "paymentType"
                        )}
                        label={"Payment Type"}
                        options={[
                          { value: 0, label: "Select Payment Type" },
                          {
                            value: 1,
                            label: "New Visa | Mastercard | Discover | AMEX",
                          },
                          // { value: 2, label: "DMC Credit Line" },
                        ]}
                        value={creditCardDetails["paymentType"]}
                        onSelect={(item) => {
                          handleChangeText("paymentType", item);
                        }}
                        isMap={true}
                      />
                      {creditCardDetails["paymentType"] == 1 && (
                        <>
                          <InputBox
                            keyboardType="numeric"
                            validate={creditCardDetailsValidation.includes(
                              "CardNum"
                            )}
                            label="Card Number"
                            placeholder="Card Number"
                            onChangeText={(text) => {
                              handleChangeText("CardNum", text);
                            }}
                            value={creditCardDetails["CardNum"]}
                          />

                          <InputBox
                            keyboardType="numeric"
                            validate={creditCardDetailsValidation.includes(
                              "CardSecurityCode"
                            )}
                            label="Card Security Code"
                            placeholder="Card Security Code"
                            onChangeText={(text) => {
                              handleChangeText("CardSecurityCode", text);
                            }}
                            value={creditCardDetails["CardSecurityCode"]}
                          />
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Dropdown
                              width="48%"
                              isValid={creditCardDetailsValidation.includes(
                                "ExpMonth"
                              )}
                              label={"Expiration Month"}
                              options={
                                expirationOption["month"] || [
                                  { value: 0, label: "--Select--" },
                                ]
                              }
                              value={creditCardDetails["ExpMonth"]}
                              onSelect={(item) => {
                                handleChangeText("ExpMonth", item["value"]);
                              }}
                              isMap={true}
                            />
                            <Dropdown
                              width="48%"
                              isValid={creditCardDetailsValidation.includes(
                                "ExpYear"
                              )}
                              label={"Expiration Year"}
                              options={
                                expirationOption["year"] || [
                                  { value: 0, label: "--Select--" },
                                ]
                              }
                              value={creditCardDetails["ExpYear"]}
                              onSelect={(item) => {
                                handleChangeText("ExpYear", item["value"]);
                              }}
                              isMap={true}
                            />
                          </View>
                          <Dropdown
                            isValid={creditCardDetailsValidation.includes(
                              "CardType"
                            )}
                            label={"Card Type"}
                            options={[
                              { value: 0, label: "--Select--" },
                              { value: 1, label: "American Express" },
                              { value: 2, label: "Visa" },
                              { value: 3, label: "MasterCard" },
                              { value: 4, label: "Discover Card" },
                            ]}
                            value={creditCardDetails["CardType"]}
                            onSelect={(item) => {
                              handleChangeText("CardType", item["value"]);
                            }}
                            isMap={true}
                          />
                          <InputBox
                            validate={creditCardDetailsValidation.includes(
                              "FirstName"
                            )}
                            label="First Name"
                            placeholder="First Name"
                            onChangeText={(text) => {
                              handleChangeText("FirstName", text);
                            }}
                            value={creditCardDetails["FirstName"]}
                          />
                          <InputBox
                            validate={creditCardDetailsValidation.includes(
                              "LastName"
                            )}
                            label="Last Name"
                            placeholder="Last Name"
                            onChangeText={(text) => {
                              handleChangeText("LastName", text);
                            }}
                            value={creditCardDetails["LastName"]}
                          />

                          <InputBox
                            validate={creditCardDetailsValidation.includes(
                              "Address"
                            )}
                            label="Billing Street Address"
                            placeholder="Billing Street Address"
                            onChangeText={(text) => {
                              handleChangeText("Address", text);
                            }}
                            value={creditCardDetails["Address"]}
                          />

                          <InputBox
                            keyboardType="numeric"
                            validate={creditCardDetailsValidation.includes(
                              "ZipCode"
                            )}
                            label="Zip Code"
                            placeholder="Zip Code"
                            onChangeText={async (text) => {
                              handleChangeText("ZipCode", text);
                            }}
                            onBlur={async () => {
                              if (creditCardDetails["ZipCode"]) {
                                let { City, State } =
                                  await handleGetZipCodeDetails(
                                    creditCardDetails["ZipCode"]
                                  );
                                setCreditCardDetails({
                                  ...creditCardDetails,
                                  ...{ City, State },
                                });
                              }
                            }}
                            value={creditCardDetails["ZipCode"]
                              ?.toString()
                              .trim()}
                          />
                          <InputBox
                            validate={creditCardDetailsValidation.includes(
                              "City"
                            )}
                            label="City"
                            placeholder="City"
                            onChangeText={(text) => {
                              handleChangeText("City", text);
                            }}
                            value={creditCardDetails["City"]}
                          />
                          <Dropdown
                            isValid={creditCardDetailsValidation.includes(
                              "State"
                            )}
                            label={"State"}
                            options={stateOptions}
                            value={creditCardDetails["State"]}
                            onSelect={(item) => {
                              handleChangeText("State", item["value"]);
                            }}
                            isMap={true}
                          />

                          <InputBox
                            validate={creditCardDetailsValidation.includes(
                              "CardEmail"
                            )}
                            label="Email a Copy of the Receipt to"
                            placeholder="Email a Copy of the Receipt to"
                            onChangeText={(text) => {
                              handleChangeText("CardEmail", text);
                            }}
                            value={creditCardDetails["CardEmail"]}
                          />
                        </>
                      )}
                    </>
                  </AccordionItem>

                  <View style={{ marginBottom: 25, display: "none" }}>
                    <Button
                      disabled={
                        processingStatus === "Next" ||
                        pageConditions["Proceed"] == 0 ||
                        productDescription?.length == 0 ||
                        creditCardDetails["paymentType"] === 0
                      }
                      onPress={(e) => {
                        if (
                          processingStatus !== "Next" &&
                          pageConditions["Proceed"] != 0 &&
                          productDescription?.length > 0 &&
                          creditCardDetails["paymentType"] !== 0
                        ) {
                          // setProcessingStatus("Next");
                          handleNextClick();
                        }
                      }}
                      title={
                        <>
                          <CustomText
                            bold={true}
                            style={[
                              {
                                fontSize: 16,
                                color: "#fff",
                                alignSelf: "center",
                                flex: 1,
                              },
                              web && { textAlign: "center" },
                            ]}
                          >
                            Next - Process Payment
                          </CustomText>
                          {processingStatus === "Next" && (
                            <>
                              {"  "}
                              <ArrowSpinner color="#fff" />
                            </>
                          )}
                        </>
                      }
                    />
                    <CustomText style={{ fontSize: 12 }}>
                      A charge will appear from Direct Services, LLC.
                    </CustomText>
                    <Separator />
                    <Separator />
                  </View>
                </View>
              )}
            </View>

            {footerButton}

            <View
              // ref={footerContainerRef}
              onLayout={(event) => {
                if (!web) {
                  let layout = event.nativeEvent.layout;
                  setTopEdge((prev) => {
                    return {
                      ...prev,
                      contentY: layout.y,
                      contentHeight: layout.height,
                    };
                  });
                }
              }}
              style={{
                height: 50,
              }}
            ></View>
          </ScrollContainer>
        )}
      </View>

      <>
        <Modal
          visible={
            alertModalMessage["messageArray"] && alertModalMessage["isShow"]
          }
          transparent
          animationType="fade"
        >
          <ScrollView style={{ flex: 1 }}>
            <TouchableOpacity
              activeOpacity={1}
              style={{
                height: "100%",
                backgroundColor: "#5454546e",
                minHeight: Dimensions.get("window").height - 30,
              }}
              onPress={
                () => {}
                // setAlertModalMessage({
                //   messageArray: null,
                //   isShow: false,
                //   headerMessage: null,
                // })
              }
            >
              <ScrollView>
                <View
                  style={[
                    {
                      width: !web ? "90%" : 600,
                      borderColor: "#d3dadf",
                      borderWidth: 0,
                      borderRadius: 5,
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                      alignSelf: "center",

                      top: web ? "30%" : "5%",
                      // left: web ? "40%" : 0,
                      left: 0,
                      opacity: 1,
                      margin: 10,
                    },
                  ]}
                >
                  <View
                    style={[styles.modalView, { maxWidth: !web ? 500 : 800 }]}
                  >
                    {/* Header */}
                    <View
                      style={{
                        flexDirection: "row",
                        borderBottomColor: "#999",
                        borderBottomWidth: 1,
                      }}
                    >
                      <CustomText
                        bold={true}
                        style={[
                          {
                            color: "#595959",
                            fontSize: 20,
                            top: -20,
                            alignItems: "flex-start",
                            flex: 1,
                          },
                          web && {
                            fontWeight: "bold",
                            position: "relative",
                          },
                        ]}
                      >
                        {alertModalMessage["headerMessage"]}
                      </CustomText>
                      <View style={{ top: -20 }}>
                        <Icon
                          name="close"
                          color="#888"
                          size={20}
                          onPress={() =>
                            setAlertModalMessage({
                              messageArray: null,
                              isShow: false,
                              headerMessage: null,
                            })
                          }
                        />
                      </View>
                    </View>
                    {/* Body */}
                    <View
                      style={{
                        paddingVertical: 15,
                        borderBottomColor: "#999",
                        borderBottomWidth: 1,
                      }}
                    >
                      {alertModalMessage["messageArray"]?.length > 0 ? (
                        <>
                          {alertModalMessage["messageArray"]?.map(
                            (item, index) => {
                              return (
                                <Fragment key={index}>
                                  <CustomText
                                    style={{
                                      fontSize: 15,
                                      marginBottom: 5,
                                    }}
                                  >{`${index + 1}. ${item}`}</CustomText>
                                </Fragment>
                              );
                            }
                          )}
                        </>
                      ) : (
                        alertModalMessage["messageArray"]
                      )}
                    </View>
                    {/* Footer */}
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "flex-end",
                      }}
                    >
                      {alertModalMessage["footerButton"] ? (
                        alertModalMessage["footerButton"]
                      ) : (
                        <ModalButton
                          title="Ok"
                          onPress={() =>
                            setAlertModalMessage({
                              messageArray: null,
                              isShow: false,
                              headerMessage: null,
                            })
                          }
                        />
                      )}
                    </View>
                  </View>
                </View>
              </ScrollView>
            </TouchableOpacity>
          </ScrollView>
        </Modal>
      </>
    </>
  );
};

const styles = StyleSheet.create({
  container: [
    {
      backgroundColor: "#fff",
      borderRadius: 5,
      overflow: "hidden",
      flex: 1,
      margin: 20,
    },
    web && {
      boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
      maxWidth: 420,
      minWidth: isMobileWeb ? 363 : 420,
      overflow: "hidden",
      flex: "none",
      padding: 20,
    },
  ],

  textSmall: {
    // fontSize: 16,
  },
  productTitle: {
    fontSize: 13,
    marginBottom: 10,
  },
  productRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  productCell: {
    flexDirection: "column",
    justifyContent: "space-between",
    alignSelf: "flex-start",
    marginBottom: 25,
  },
  productName: [
    {
      color: "#428bca",
      fontSize: 14,
    },
    web ? { cursor: "pointer" } : {},
  ],
  productAmount: [
    {
      fontSize: 12,
      paddingHorizontal: 10,
      paddingVertical: 8,
      backgroundColor: "#f5f5f5",
      textAlign: "right",
    },
  ],
  row: { flexDirection: "row", marginBottom: 5 },

  borrowerTitle: {
    minWidth: 150,
    // textAlign: "right",
    // marginRight: 10,
  },
  modalView: {
    // margin: 20,
    width: "100%",
    backgroundColor: "white",
    borderRadius: 5,
    paddingVertical: 35,
    paddingHorizontal: 20,
    // alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    top: "50%",
  },
  buttonContainer: {
    backgroundColor: "#295b9a",
    borderRadius: 25,
    height: 45,
    paddingVertical: web ? 10 : 5,
    paddingHorizontal: web ? 10 : 5,
    marginTop: 20,
    paddingTop: web ? "5px" : null,
    alignSelf: "flex-start",
    justifyContent: "center",
    // marginLeft: 15,
  },
  tableRow: {
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 10,
    alignItems: "center",
  },
  cell: {
    fontSize: web ? 13 : 12,
    maxWidth: web ? 150 : 100,
    minWidth: web ? 150 : 50,
    color: "#595959",
    lineHeight: 15,
    marginRight: 15,
  },
});
export default AppraisalPayment;
